import track from "./track";
const roamingCalc = new Vue({
    el: '#modalCallNow',
    data() {
        return {
            showCallNow: true,
            loading: false,
            locale: 'ca',
            privacy: false,
            name: null,
            phone: null,
            message: null,
            errors: {
                name: {
                    text: null,
                    status: null,
                },
                phone: {
                    text: null,
                    status: null,
                },
                privacy: {
                    status: null
                }
            },
            disabledButton: true,
        }
    },
    created: async function() {
        const section = document.getElementById('modalCallNow')
        if(section) {
            section.removeAttribute('hidden');
        }
        webStorage.prefix = 'callnow';
        const key = webStorage.get('modal_button');

        if(key === 'disabled') {
            this.showCallNow = false;
        }
    },
    mounted: function () {
        this.locale = document.getElementsByTagName('html')[0].getAttribute('lang');
        if(document.querySelector('#cookie-consent div') && document.querySelector('#modalCallNow > a')){
            if(document.querySelector('#cookie-consent div').style.display === 'block'){
                document.querySelector('#modalCallNow > a').classList.add('move');
            }
        }

        let vm = this;
        $('#modal-call-me-now').on('hidden.bs.modal', function (e) {
            vm.message = null;
            vm.name = null;
            vm.phone = null;
            vm.privacy = false;
            vm.errors.privacy.status = false;
            vm.errors.phone.status = false;
            vm.errors.name.status = false;
        })
    },
    beforeDestroy: function () {
        $('#modal-call-me-now').off('hidden.bs.modal');
    },
    methods: {
        analytics() {
            track.event({
                eventCategory: "phone",
                eventAction: "callmeback-button",
                eventLabel: ""
            })
        },
        send() {
            this.loading = true;
            this.errors.privacy.status = false;
            this.errors.phone.status = false;
            this.errors.name.status = false;
            //check
            this.errors.name.status = !this.name;
            this.errors.privacy.status = !this.privacy;
            if(!this.phone){
                this.errors.phone.status = true;
            }else {
                if(this.phone.length < 9 || this.phone.length > 15 ) {
                    this.errors.phone.status = true;
                }
            }
            if(this.errors.name.status || this.errors.phone.status || this.errors.privacy.status){
                this.loading = false;
                return
            }
            this.phone = this.phone.trim();

            if(this.phone.includes('+34')) {
                this.phone = this.phone.replaceAll(' ', '');
                this.phone = this.phone.replaceAll('+34', '');
            }

            this.message = 'Et trucarem ben aviat, estigues al cas!';
            track.event({
                eventCategory: "phone",
                eventAction: "callmeback-send",
                eventLabel: ""
            })
            window.criteo_q = window.criteo_q || [];
            var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
            window.criteo_q.push(
                { event: "setAccount", account: 91391},
                { event: "setSiteType", type: deviceType},
                { event: "trackTransaction", id: Math.floor(Math.random()*99999999999)+1, item: [
                        {id: "1", price: "1", quantity: "1" }
                    ]}
            );
            axios.post('/api/v1/call-now', {
                name: this.name,
                phone: this.phone,
                lang: this.locale,
            })
                .then((data) => {
                    this.errorsReset();
                    if(this.locale === 'ca') {
                        this.message = 'Et trucarem ben aviat, estigues al cas!';
                    } else {
                        this.message = 'Te llamaremos pronto, mantente al caso!';
                    }

                })
                .catch((error) => {
                    this.loading = false;
                    if (error.response) {
                        if (error.response.status === 429) {
                            this.message = error.response.data
                        }
                        else if (error.response.status === 422) {
                            if (error.response.data.errors.name) {
                                this.errors.name.text = error.response.data.errors.name;
                                this.errors.name.status = true;
                            }
                            if (error.response.data.errors.phone) {
                                this.errors.phone.text = error.response.data.errors.phone;
                                this.errors.phone.status = true;
                            }
                        }
                    }
                });
        },
        errorsReset() {
            this.errors = {
                name: {
                    text: null,
                    status: null,
                },
                phone: {
                    text: null,
                    status: null,
                },
            }
            this.loading = false;
        },
        alert(event) {
            this.showCallNow = false;
            webStorage.store('callnow').put('modal_button', 'disabled', 60 * 60 * 24)
            event.stopPropagation();
        }
    }
})
